"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlerts = exports.addAlerts = void 0;

var corona_1 = require("corona");

var alerts_1 = require("../types/alerts");

function addAlerts(alerts) {
  return {
    type: alerts_1.ADD_ALERTS,
    alerts: alerts
  };
}

exports.addAlerts = addAlerts;

function getAlerts(time) {
  return function (dispatch, getState) {
    return corona_1.Alerts.get(getState().authentication, time).then(function (alerts) {
      dispatch(addAlerts(alerts));
    });
  };
}

exports.getAlerts = getAlerts;